import { createApp } from 'vue'
import { install as VueMonacoEditorPlugin } from '@guolao/vue-monaco-editor'
import App from './App.vue'
import router from './router'
import i18n from './i18n'

// Create Vue app
const app = createApp(App)

// Use plugins
app.use(router)
app.use(i18n)
app.use(VueMonacoEditorPlugin, {
    // Use jsDelivr CDN for fast access in China/Global
    paths: {
        vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.44.0/min/vs'
    }
})

// Mount app
app.mount('#app')
